import { cn } from '@/trailmix/lib/cn';
import { getImageFromCDN } from '@/image-cdn';

type Photo = {
    id: number;
    path: string;
};

type StackedPhotosProps = {
    photos: Photo[];
    totalCount?: number;
    photoWidth?: number;
    photoHeight?: number;
    className?: string;
};

export function StackedPhotos({
    photos,
    totalCount,
    photoWidth = 120,
    photoHeight = 90,
    className,
}: StackedPhotosProps) {
    if (photos.length === 0) {
        return null;
    }

    // Render oldest first so the most recent photo ends up on top (rightmost)
    const displayPhotos = [...photos.slice(0, 5)].reverse();
    const remainingCount = totalCount !== undefined ? totalCount - displayPhotos.length : null;
    const showOverflow = remainingCount !== null && remainingCount > 0;
    const n = displayPhotos.length;

    return (
        <div className={cn('flex w-full items-center gap-2 desktop:max-w-lg', className)}>
            <div className='relative flex-1' style={{ height: photoHeight + 10 }}>
                {displayPhotos.map((photo, i) => (
                    <div
                        key={photo.id}
                        className='absolute rounded-lg border-4 border-white bg-white shadow-lg'
                        style={{
                            width: photoWidth,
                            height: photoHeight,
                            left: n > 1 ? `calc(${i} * (100% - ${photoWidth}px) / ${n - 1})` : 0,
                            top: 5,
                            zIndex: i,
                        }}
                    >
                        <img
                            src={getImageFromCDN({ path: photo.path, size: 'small' }).toURL()}
                            className='h-full w-full overflow-hidden rounded-md object-cover'
                            alt=''
                        />
                    </div>
                ))}
            </div>
            {showOverflow && (
                <div
                    className='flex shrink-0 items-center justify-center rounded-lg border-4 border-white bg-gray-100 shadow-lg'
                    style={{ width: 48, height: photoHeight }}
                >
                    <span className='text-sm font-semibold text-gray-400'>+{remainingCount}</span>
                </div>
            )}
        </div>
    );
}
